// extracted by mini-css-extract-plugin
module.exports = {"page-header":"Page_page-header__3FLf9","page-title":"Page_page-title__3qoVu","page-description":"Page_page-description__1iJ8Q"};